import * as React from 'react';

import { BetType } from '@/lib/apollo/types/gen/graphql';
import { getBetMethodName, getBetTypeName } from '@/lib/race';
import { BetMethod } from '@/modelTypes';

import { BetName, IconMulti } from './style';

const TicketHeader: React.FC<{
  method: BetMethod;
  type: BetType;
  multi: boolean;
}> = ({ method, type, multi }) => {
  const typeName = getBetTypeName(type);
  const methodName = getBetMethodName(method);
  return (
    <BetName>
      {typeName} {methodName} {multi && <IconMulti>マ</IconMulti>}
    </BetName>
  );
};

export default TicketHeader;
